import type { SubjectFieldOptionPayload } from '@Application/SubjectTypes/Actions/subjectTypesFetched';

/** One choice of a `choice` or `multiple_choice` field: the value is sent, the label is shown. */
class SubjectFieldOptionView {
	readonly value: string;
	readonly label: string;

	constructor(payload: SubjectFieldOptionPayload) {
		this.value = payload.value;
		this.label = payload.label;

		Object.freeze(this);
	}
}

export default SubjectFieldOptionView;
